(() => {
const $f560b1a8e20a780b$var$header = document.querySelector("#header");
const $f560b1a8e20a780b$var$menu = $f560b1a8e20a780b$var$header.querySelector("#header-menu");
const $f560b1a8e20a780b$var$allIterableItems = $f560b1a8e20a780b$var$header.querySelectorAll("#header-menu details, #header-icons > details, #header-icons > a, .fcb-header__logo-wrapper a ");
const $f560b1a8e20a780b$var$menuDetails = $f560b1a8e20a780b$var$header.querySelectorAll("#header-menu details");
const $f560b1a8e20a780b$var$desktopLinks = $f560b1a8e20a780b$var$header.querySelectorAll(".fcb-header__menu a.fcb-header__menu-item");
const $f560b1a8e20a780b$var$details = $f560b1a8e20a780b$var$header.querySelectorAll("details");
const $f560b1a8e20a780b$var$body = document.body;
const $f560b1a8e20a780b$var$closeAllMenus = ()=>{
    $f560b1a8e20a780b$var$menuDetails.forEach((detailsElement)=>detailsElement.removeAttribute("open"));
};
// Cambios alberto
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" || event.key === "Esc") {
    $f560b1a8e20a780b$var$closeAllMenus();
  }
});
$f560b1a8e20a780b$var$desktopLinks.forEach((link)=>{
    link.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
    });
});
$f560b1a8e20a780b$var$allIterableItems.forEach((link)=>{
    link.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
    });
});
$f560b1a8e20a780b$var$menuDetails.forEach((detailsElement)=>{
    detailsElement.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
        detailsElement.setAttribute("open", true);
    });
});
// Cambios alberto
$f560b1a8e20a780b$var$desktopLinks.forEach((link)=>{
    link.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
    });
});
$f560b1a8e20a780b$var$allIterableItems.forEach((link)=>{
    link.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
    });
});
$f560b1a8e20a780b$var$menuDetails.forEach((detailsElement)=>{
    detailsElement.addEventListener("mouseover", ()=>{
        $f560b1a8e20a780b$var$closeAllMenus();
        detailsElement.setAttribute("open", true);
    });
});
$f560b1a8e20a780b$var$header.addEventListener("mouseleave", $f560b1a8e20a780b$var$closeAllMenus);
// DRAWER
const $f560b1a8e20a780b$var$drawer = $f560b1a8e20a780b$var$header.querySelector(".fcb-header__drawer");
const $f560b1a8e20a780b$var$toggleDrawerBtn = $f560b1a8e20a780b$var$header.querySelector(".fcb-header__drawer > summary");
const $f560b1a8e20a780b$var$drawerDetails = $f560b1a8e20a780b$var$drawer.querySelectorAll(".fcb-header__drawer__details");
const $f560b1a8e20a780b$var$closeAllDetails = ()=>{
    $f560b1a8e20a780b$var$drawerDetails.forEach((drawerDetailsElement)=>{
        drawerDetailsElement.removeAttribute("open");
    });
    $f560b1a8e20a780b$var$drawer.removeAttribute("open");
};
$f560b1a8e20a780b$var$drawer.addEventListener("toggle", ()=>{
    if ($f560b1a8e20a780b$var$drawer.hasAttribute("open")) {
        $f560b1a8e20a780b$var$toggleDrawerBtn.setAttribute("aria-expanded", true);
        $f560b1a8e20a780b$var$body.style.overflow = "hidden";
    } else {
        $f560b1a8e20a780b$var$toggleDrawerBtn.setAttribute("aria-expanded", false);
        $f560b1a8e20a780b$var$body.style.overflow = "auto";
    }
});
$f560b1a8e20a780b$var$drawerDetails.forEach((drawerDetailsElement)=>{
    const buttonBack = drawerDetailsElement.querySelector(".fcb-header__drawer__submenu .fcb-header__drawer__submenu__back");
    const summary = drawerDetailsElement.querySelector("summary");
    const parentContent = drawerDetailsElement.closest(".fcb-header__drawer__content");
    const onToggle = ()=>{
        if (drawerDetailsElement.hasAttribute("open")) summary.setAttribute("aria-expanded", true);
        else summary.setAttribute("aria-expanded", false);
    };
    drawerDetailsElement.addEventListener("toggle", onToggle);
    buttonBack.addEventListener("click", ()=>{
        drawerDetailsElement.classList.add("is-closing");
        const onAnimationEnd = ()=>{
            drawerDetailsElement.removeAttribute("open");
            drawerDetailsElement.classList.remove("is-closing");
            drawerDetailsElement.removeEventListener("animationend", onAnimationEnd);
        };
        drawerDetailsElement.addEventListener("animationend", onAnimationEnd);
    });
});
// Drawer Localization Form
class $f560b1a8e20a780b$var$LocalizationForm extends HTMLElement {
    constructor(){
        super();
        this.elements = {
            input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
        };
        this.querySelectorAll("a").forEach((item)=>item.addEventListener("click", this.onItemClick.bind(this)));
    }
    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }
}
customElements.define("drawer-localization-form", $f560b1a8e20a780b$var$LocalizationForm);
// SEARCH
const $f560b1a8e20a780b$var$headerSearch = $f560b1a8e20a780b$var$header.querySelector("#header-search");
const $f560b1a8e20a780b$var$headerSearchCancel = $f560b1a8e20a780b$var$headerSearch.querySelector("#header-search-cancel");
const $f560b1a8e20a780b$var$headerSearchInput = $f560b1a8e20a780b$var$headerSearch.querySelector("#Search-In-Modal");
const $f560b1a8e20a780b$var$searchOverlay = $f560b1a8e20a780b$var$header.querySelector(".fcb-header-search__overlay");
const $f560b1a8e20a780b$var$closeSearch = ()=>{
    $f560b1a8e20a780b$var$headerSearch.removeAttribute("open");
    document.removeEventListener("keydown", $f560b1a8e20a780b$var$closeSearchOnEsc);
};
const $f560b1a8e20a780b$var$closeSearchOnEsc = (ev)=>{
    if (ev.keyCode == 27) $f560b1a8e20a780b$var$closeSearch();
};
$f560b1a8e20a780b$var$searchOverlay?.addEventListener("click", ()=>{
    $f560b1a8e20a780b$var$closeSearch();
});
$f560b1a8e20a780b$var$headerSearchCancel.addEventListener("click", ()=>{
    $f560b1a8e20a780b$var$closeSearch();
});
$f560b1a8e20a780b$var$headerSearch.addEventListener("toggle", ()=>{
    if ($f560b1a8e20a780b$var$headerSearch.hasAttribute("open")) {
        document.addEventListener("keydown", $f560b1a8e20a780b$var$closeSearchOnEsc);
        $f560b1a8e20a780b$var$body.style.overflow = "hidden";
    } else $f560b1a8e20a780b$var$body.style.overflow = "auto";
});
//Cambios alberto
const modal = document.querySelector(".md-modal__container");
const focusableSelectors = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

function trapFocus(modal) {
  const allFocusable = Array.from(document.querySelectorAll(focusableSelectors));
  const modalFocusable = Array.from(modal.querySelectorAll(focusableSelectors));

  const outsideFocusable = allFocusable.filter(el => !modal.contains(el));

  outsideFocusable.forEach(el => {
    if (!el.hasAttribute('data-tabindex')) {
      el.setAttribute('data-tabindex', el.getAttribute('tabindex') ?? '');
    }
    el.setAttribute('tabindex', '-1');
    el.setAttribute('aria-hidden', 'true');  
  });

  function restoreFocus() {
    outsideFocusable.forEach(el => {
      const originalTabindex = el.getAttribute('data-tabindex');
      if (originalTabindex === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', originalTabindex);
      }
      el.removeAttribute('data-tabindex');
      el.removeAttribute('aria-hidden');
    });

    modal.removeEventListener('close', restoreFocus);
  }

  modal.addEventListener('close', restoreFocus);
}

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'open') {
      if (modal.hasAttribute('open')) {
        trapFocus(modal);
      } else {
        
        modal.dispatchEvent(new Event('close'));
      }
    }
  });
});

observer.observe(modal, { attributes: true });

})();
//# sourceMappingURL=menu-header.js.map
